import { Grid } from '@mui/material'
import { AppBox, AppButton, AppTypography } from 'components'
import { FC } from 'react'
import { useAppDispatch } from 'store/app.store'
import { closeOldPaidMembersSubscriptionDialog, openChangeMembershipDialog } from 'store/slices'

interface Props {}

export const OldPaidMembersUpgradePlandialog: FC<Props> = () => {
  const dispatch = useAppDispatch()
  const handleUpgrdeClick = () => {
    dispatch(closeOldPaidMembersSubscriptionDialog())
    dispatch(openChangeMembershipDialog())
  }
  return (
    <AppBox>
      <AppTypography color={'grey.500'} fontSize={14} fontWeight={500}>
        Looks like you have a legacy subscription plan!
      </AppTypography>
      <AppTypography color={'grey.500'} fontSize={14}>
        According to our records you currently have one of our older legacy subscription plans. We truly appreciate your
        loyalty, but we’ve also matured a lot since those days. That’s why we’re offering two options for you.
      </AppTypography>
      <Grid container paddingTop={2} spacing={4}>
        <Grid item xs={8}>
          <AppBox paddingBottom={2}>
            <AppTypography fontSize={14} fontWeight={'bold'}>
              Use your existing plan
            </AppTypography>
            <AppTypography color={'grey.500'} paddingTop={1}>
              You can choose to continue using your existing legacy subscription plan. With this option the only
              limitation you will experience is the inability to add additional users and the ability to create an{' '}
              <b>Outside Team.</b>
            </AppTypography>
          </AppBox>
          <AppBox borderTop={1} borderColor={'grey.300'} paddingTop={2}>
            <AppTypography fontSize={14} fontWeight={'bold'}>
              Upgrade your plan
            </AppTypography>
            <AppTypography color={'grey.500'} paddingTop={1}>
              You can choose to upgrade your existing subscription to one of our newer plans. With this option you’ll be
              able to add users to your plan and create an <b>Outside Team</b> to invite other paid accounts to work in
              your space.
            </AppTypography>
            <AppBox width={'100%'} textAlign={'right'}>
              <AppButton variant="contained" size="small" onClick={handleUpgrdeClick}>
                Upgrade Plan
              </AppButton>
            </AppBox>
          </AppBox>
        </Grid>
        <Grid item xs={4}>
          <img src="/images/pax/OldPaidMembersInfo.png" alt="Pax Image" />
        </Grid>
      </Grid>
    </AppBox>
  )
}
